export const calculatorConstants = {
    CURRENTVAL: 'CURRENTVAL',
}
